import { FiscalCalType, PatternType } from "@blisspointmedia/bpm-types/dist/FiscalCalendar";
import { DropdownToggleType } from "../Components";

export const YEARLY_MONTH_TO_INDEX_OPTIONS = [
  { value: 0, label: "January", disabled: true },
  { value: 1, label: "February" },
  { value: 2, label: "March" },
  { value: 3, label: "April" },
  { value: 4, label: "May" },
  { value: 5, label: "June" },
  { value: 6, label: "July" },
  { value: 7, label: "August" },
  { value: 8, label: "September" },
  { value: 9, label: "October" },
  { value: 10, label: "November" },
  { value: 11, label: "December" },
];

export const CAL_TYPES_RADIO_OPTIONS = [
  { value: "traditional", label: "Traditional Calender Year" },
  { value: "yearly", label: "Fiscal - Yearly" },
  { value: "pattern", label: "Fiscal - Pattern Driven" },
];

export const WEEK_DEFINITION_OPTIONS = [
  { value: 0, label: "Sunday – Saturday" },
  { value: 1, label: "Monday – Sunday" },
  { value: 2, label: "Tuesday – Monday" },
  { value: 3, label: "Wednesday – Tuesday" },
  { value: 4, label: "Thursday – Wednesday" },
  { value: 5, label: "Friday – Thursday" },
  { value: 6, label: "Saturday – Friday" },
];

export const EXTRA_WEEK_YEAR_OPTIONS = [
  { value: 2017, label: "2017" },
  { value: 2018, label: "2018" },
  { value: 2019, label: "2019" },
  { value: 2020, label: "2020" },
  { value: 2021, label: "2021" },
  { value: 2022, label: "2022" },
  { value: 2023, label: "2023" },
  { value: 2024, label: "2024" },
  { value: 2025, label: "2025" },
  { value: 2026, label: "2026" },
  { value: 2027, label: "2027" },
  { value: 2028, label: "2028" },
  { value: 2029, label: "2029" },
  { value: 2030, label: "2030" },
];

export const PATTERN_OPTIONS = [
  {
    value: PatternType.PATTERN_A,
    label: "4 - 4 - 5",
  },
  {
    value: PatternType.PATTERN_B,
    label: "4 - 5 - 4",
  },
];

const DROPDOWN_STYLE = {
  type: DropdownToggleType.OUTLINED,
  design: "primary",
};

export const NESTED_QUESTION_CONFIG = {
  [FiscalCalType.YEARLY]: [
    {
      inputType: "dropdown",
      label: "Current fiscal year start month",
      options: YEARLY_MONTH_TO_INDEX_OPTIONS,
      dropdownProps: DROPDOWN_STYLE,
      formPath: "seedDate",
      note: "If your calendar starts in January, select Traditional Calendar Year.",
    },
  ],
  [FiscalCalType.PATTERN]: [
    {
      inputType: "datefield",
      label: "Fiscal year start date:",
      formPath: "seedDate",
    },
  ],
};

export const YEAR_LABEL_CURRENT_QUESTION = {
  inputType: "dropdown",
  label: "That date marks the start of the year:",
  dropdownProps: DROPDOWN_STYLE,
  formPath: "yearLabelCurrent",
  note:
    "Tip: This usually matches the year in your start date unless that date is toward the end of the calendar year.",
};

export const MONTH_LABEL_CURRENT_QUESTION = {
  inputType: "dropdown",
  label: "Fiscal year start month name:",
  dropdownProps: DROPDOWN_STYLE,
  formPath: "monthLabelCurrent",
  note:
    "Tip: This usually matches the month in your start date unless that date is towards the end of the month.",
};

export const PATTERN_QUESTION = {
  label: "What pattern do you use?",
  inputType: "dropdown",
  options: PATTERN_OPTIONS,
  dropdownProps: DROPDOWN_STYLE,
  formPath: "pattern",
  subHeader:
    "This sets the number of weeks per fiscal month, beginning with your fiscal year start date.",
};
// export const PATTERN_SUBHEADER = "This sets the number of weeks per fiscal month, beginning with your fiscal year start date.";

export const WEEK_DEFINITION_NOTE = [
  'This week definition is determined by your “current fiscal year start date."',
  "If it's incorrect, your fiscal year start date is entered incorrectly.",
];

export const OVERWRITE_NOTE =
  "You're about to overwrite the existing calendar. This will change how data is broken out by date intervals in the app.  Are you sure you want to continue?";
export const EXTRA_WEEK_TIPS = [
  "53-week years usually occur every 5–6 years.",
];
